/**
 * Created by yougen.zhuangyg on 2014/9/19.
 */

/**
* refactor security code
*
*/

    var $ = require('@alife/alpha-jquery/jquery');

    var CheckCode = function(config){
        this.init(config);
    };

    CheckCode.prototype = {
        init: function(config){
            if(config.view){
                this.el =  config.view.el;
                this.dialog = config.dialog;
            }else {
                this.el = config.el;
            }
            var self = this;
            this.codeImg = this.el.find('[data-role=check-code-image]');
            this.codeImg.on("click", function(){
                 self.refresh();
            });
        },

        //检查是否需要验证码
        validate: function(){
            if(this.getCollinaCheck() && this.getUAValue() == '' && this.getValue() == ''){
                return false;
            }
            return true;
        },

        //人机识别重新记录
        uaReload: function(){
            if(window.UA_Opt){
                window.UA_Opt.Token = new Date().getTime() + ":" + Math.random();
                if(window.UA_Opt.reload){
                    window.UA_Opt.reload();
                }
            }
        },

        focus: function(){
            if(this.el){
                this.el.focus();
            }
        },
        //显示校验码
        show: function(){
            if(!this.el){ return ;}
            this.clear();
            if(this.dialog){
                this.dialog.show();
            }else if(this.el){
                this.el.show();
            }
            this.refresh();
        },
        hide: function(){
            if(this.dialog){
                this.dialog.hide();
                return;
            }
            if(this.el){
                this.el.hide();
            }

        },
        clear: function(){
            if(this.el) {
                var input= this.el.find('[data-role=check-code-input]');
                if(input){
                    input.val('');
                }
            }
        },
        reset: function(){
            this.refresh();
            this.clear();
            this.uaReload();
        },
        // 刷新验证码
        refresh:function(){
            if(this.el) {
                var el = this.el.find('[data-role=check-code-image]');
                if (el) {
                    var f = Math.random(),
                        url = el.attr('data-src') + '&random=' + f;
                    el.prop('src', url);
                }
            }
        },
        getUAValue: function(){
            if(window.uaInputVar && location.href.indexOf('_ua=false') != -1 ){
                return '';
            }
            var val = window.uaInputVar;
            return (val ? val : '');
        },
        getPostData: function(context){
            this.context = context;
            var securityObj = CheckCode.getSecurityData();

            var inputName = securityObj['checkCodeName'],
                retData = {
                    ua: this.getUAValue(),
                    _csi_: securityObj['sId'] || '',
                    umidToken: securityObj['umidToken'] || ''
                };

            if(inputName){
                retData[inputName] = this.getValue();
            }
            this.uaReload();
            return retData;
        },

        getValue: function(){
            if(this.el && this.el.find('[data-role=check-code-input]')){
                return $.trim(this.el.find('[data-role=check-code-input]').val());
            }
            return '';
        },
        //获取是否开启人机识别
        getCollinaCheck: function(){
            return !!(CheckCode.getSecurityData()['collinaCheck']);
        },
        needTrustcheck: function(){
            return !!(CheckCode.getSecurityData()['trustCheck']);
        }

    };

    CheckCode.getSecurityData = function(){
        var data = window['image-check-code'] || window['DATA_CHECK_CODE'] || {};
        $.extend(data, {umidToken: window['umidToken']});
        return data;
    };
    module.exports = CheckCode;

